import richTextFragment from '@components/renderers/rich-text.fragment'
import { marketingFormEmbedFragment } from '@components/marketing-form-embed/marketing-form-embed.fragment'
import { testimonialV2Fragment } from '@components/testimonialv2/testimonialv2.fragment'

const workInGolfFragment = `
  metaDataField
  metaImage {
    url
  }
  metaDescription
  heroVideoBackground {
    description
    contentType
    url
    width
    height
  }
  heroScrollCarouselCollection(limit: 3) {
    items {
      heroScrollCarouselHeadingPrecedingCopy
      heroScrollCarouselHeading
      heroScrollCarouselBgImage {
        description
        contentType
        url
        width
        height
      }
      heroScrollCarouselButtonLabel
      heroScrollCarouselCtaLink
      description
      ctaBoxText
      ctaBoxLinkText
      ctaBoxUrl
    }
  }
  videoSpotlight {
    headline
    overlineText
    description {
      ${richTextFragment}
    }
    ctaText
    link
    videoImage {
      url
      description
    }
    video {
      url
      description
    }
    videoEmbedId
  }
  careerTracksSection {
    sectionHeading
    overline
    subtitle
    ctaButtonLabel
    ctaButtonLink
    imageAssociatedWithVideo {
      description
      contentType
      url
      width
      height
    }
    modalVIdeo {
      description
      contentType
      url
      width
      height
    }
    trackCardsCollection(limit: 3) {
      items {
        precedingHeading
        heading
        cardImage {
          description
          contentType
          url
          width
          height
        }
        overlayList
      }
    }
  }
  statisticsHeadline
  statisticsSubtitle
  statisticsCardsCollection(limit: 3) {
    items {
      heading
      subtitle
    }
  }
  listCardAccordionSection {
    heading
    supportiveCopy
    ctaLabel
    ctaLink
    desktopBackgroundImage {
      description
      contentType
      url
      width
      height
    }
    accordionCollection(limit: 10) {
      items {
        accordionTitleIcon {
          description
          contentType
          url
          width
          height
        }
        accordionTitle
        accordionDetailHeading
        accordionDetailList
        accordionDetailBlurb
        accordionDetailCtaLink
        accordionDetailCtaLabel
        backgroundImage {
          description
          contentType
          url
          width
          height
        }
      }
    }
  }
  testimonialsSection {
    ${testimonialV2Fragment}
  }
  journeyAndJobsSection {
    heading
    supportiveCopy
    ctaLabel
    ctaLink
    ctaCardsCollection(limit: 2) {
      items {
        heading
        supportiveCopy
        ctaLabel
        ctaLink
        backgroundImage {
          description
          contentType
          url
          width
          height
        }
      }
    }
  }
  pathToGolfSection {
    sectionHeading
    sectionSupportiveCopy
    ctaButtonLabel
    ctaButtonLink
    ctaBoxHeadline
    ctaBoxSubtitle
    ctaBoxButtonLabel
    ctaBoxButtonLink
    backgroundImage {
      description
      contentType
      url
      width
      height
    }
    trackCardsCollection(limit: 2) {
      items {
        heading
        subheading
        cardImage {
          description
          contentType
          url
          width
          height
        }
        ctaText
        ctaLink
      }
    }
  }
  careerSpecialistSection {
    hideBox
    heading
    supportiveCopy
    buttonLabel
    buttonLink
    cardImage {
      description
      contentType
      url
      width
      height
    }
    backgroundImage {
      description
      contentType
      url
      width
      height
    }
    cardHeading
    cardSupportiveCopy
  }
  newsletterSignup {
    ${marketingFormEmbedFragment}
  }
`

export default workInGolfFragment
